import config from '@/config';
import axios from 'axios';

export const visit = {
  namespaced: true,
  state: {
    formLoading: false,
    selectedCarModelID: null,
    selectedLicensePlate: null,
    selectedVin: null,
    selectedPartner: null,
    selectedServices: [],
    selectedVisitDate: null,
    availableDates: null,
    price: null,
    registeredVisit: null,
    mileage: 0,
    showHistoryVisits: false,
    submitTrigger: false,
  },
  getters: {
    formLoading(state) {
      return state.formLoading;
    },
    selectedPartner(state) {
      return state.selectedPartner;
    },
    selectedCarModelID(state) {
      return state.selectedCarModelID;
    },
    selectedServices(state) {
      return state.selectedServices;
    },
    selectedVisitDate(state) {
      return state.selectedVisitDate;
    },
    availableDates(state) {
      return state.availableDates;
    },
    price(state) {
      return state.price;
    },
    selectedLicensePlate(state) {
      return state.selectedLicensePlate;
    },
    selectedVin(state) {
      return state.selectedVin;
    },
    registeredVisit(state) {
      return state.registeredVisit;
    },
    mileage(state) {
      return state.mileage;
    },
    showHistoryVisits(state) {
      return state.showHistoryVisits;
    },
    submitTrigger(state) {
      return state.submitTrigger;
    },
  },
  mutations: {
    setFormLoading(state, value) {
      state.formLoading = value;
    },
    setSubmitTrigger(state) {
      state.submitTrigger = !state.submitTrigger;
    },
    setSelectedVin(state, vin) {
      state.selectedVin = vin;
      sessionStorage.setItem('selectedVin', vin);
    },
    setSelectedLicensePlate(state, licensePlate) {
      state.selectedLicensePlate = licensePlate;
      sessionStorage.setItem('selectedLicensePlate', licensePlate);
    },
    setSelectedPartner(state, partner) {
      state.selectedPartner = partner;
      sessionStorage.setItem('selectedPartner', JSON.stringify(partner));
    },
    setSelectedCarModelID(state, id) {
      state.selectedCarModelID = id ? parseInt(id, 10) : null;
      sessionStorage.setItem('selectedCarModelID', JSON.stringify(parseInt(id, 10)));
    },
    setSelectedServices(state, service) {
      state.selectedServices = service;
      sessionStorage.setItem('selectedServices', JSON.stringify(service));
    },
    setAvailableDates(state, dates) {
      state.availableDates = dates;
    },
    setSelectedVisitDate(state, date) {
      state.selectedVisitDate = date;
      sessionStorage.setItem('selectedVisitDate', JSON.stringify(date));
    },
    setPrice(state, price) {
      state.price = price;
    },
    setRegisteredVisit(state, registeredVisit) {
      state.registeredVisit = registeredVisit;
      sessionStorage.setItem('registeredVisit', JSON.stringify(registeredVisit));
    },
    setMileage(state, mileage) {
      state.mileage = mileage;
    },
    setShowHistoryVisits(state, value) {
      state.showHistoryVisits = value;
    },
  },
  actions: {
    fetchAvailableDates({ dispatch, state }, data) {
      const parsedEndpoint = config.apiEndpoints.availablePartnerDates.replace('id', data.partnerID);
      const services = state.selectedServices.map(service => service.id);

      return new Promise((resolve, reject) => {
        axios.get(config.apiUrl + parsedEndpoint, {
          params: {
            services,
            car: state.selectedCarModelID,
            visit: data.visitID,
          },
        })
          .then((res) => {
            if (res.status === 200) {
              dispatch('setAvailableDates', res.data.slots);
              resolve(res);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    loadSavedData({ commit }) {
      // eslint-disable-next-line max-len
      const keys = ['selectedCarModelID', 'selectedVin', 'selectedLicensePlate', 'selectedPartner', 'selectedServices', 'selectedVisitDate', 'registeredVisit']
      keys.forEach((key) => {
        const shouldBeParsed = !['selectedCarModelID', 'selectedVin', 'selectedLicensePlate'].includes(key);
        const actionName = `set${key.charAt(0).toUpperCase() + key.slice(1)}`;
        if (shouldBeParsed) {
          commit(actionName, JSON.parse(sessionStorage.getItem(key)));
        } else {
          commit(actionName, sessionStorage.getItem(key));
        }
      });
    },
    setFormLoading({ commit }, value) {
      commit('setFormLoading', value);
    },
    setMileage({ commit }, mileage) {
      commit('setMileage', mileage);
    },
    setSelectedPartner({ commit }, partner) {
      commit('setSelectedPartner', partner);
    },
    setSelectedCarModelID({ commit }, id) {
      commit('setSelectedCarModelID', id);
    },
    setSelectedServices({ commit }, service) {
      commit('setSelectedServices', service);
    },
    setSelectedVisitDate({ commit }, date) {
      commit('setSelectedVisitDate', date);
    },
    setPrice({ commit }, price) {
      commit('setPrice', price);
    },
    setSelectedLicensePlate({ commit }, licensePlate) {
      commit('setSelectedLicensePlate', licensePlate);
    },
    setSelectedVin({ commit }, vin) {
      commit('setSelectedVin', vin);
    },
    setRegisteredVisit({ commit }, registeredVisit) {
      commit('setRegisteredVisit', registeredVisit);
    },
    setShowHistoryVisits({ commit }, value) {
      commit('setShowHistoryVisits', value);
    },
    setSubmitTrigger({ commit }) {
      commit('setSubmitTrigger');
    },
    setAvailableDates({ commit }, dates) {
      commit('setAvailableDates', dates);
    },
  },
};
